import React from 'react';
import propTypes from 'prop-types';
import { Button, ButtonGroup } from 'reactstrap';

import { makeId } from 'utils/selectors';
import sharedStyles from 'app/shared.css';

import HelpIcon from './HelpIcon';
import styles from './ButtonList.css';

/**
 * render an array of values as an inline button group
 * @param {object} props - props passed to the component
 * @returns {React.Component} - ButtonList canvas widget
 */
const ButtonList = ({
  fieldContract: { allowedValues = [], helpText, name, required },
  isReadonly,
  onChange,
  selectedValue,
  updateLocation,
  validationMessage
}) => (
  <div className="d-flex flex-column my-3">
    <span className="d-flex align-items-center font-weight-bold mb-2">
      {`${name}${required ? '*' : ''}`}
      {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
    </span>
    <div className={!validationMessage ? {} : sharedStyles.invalid}>
      <ButtonGroup
        className={`d-flex w-100 ${styles.wrapper}`}
        size="sm"
        data-test-id={makeId({ updateLocation })}
      >
        {allowedValues.map((displayName, ind) => (
          <Button
            key={displayName}
            className={`flex-fill ${
              styles[selectedValue === ind ? 'selected' : 'notSelected']
            }`}
            disabled={isReadonly}
            outline={selectedValue !== ind}
            onClick={() => onChange(ind)}
            data-test-id={makeId({ updateLocation, value: displayName })}
          >
            {displayName}
          </Button>
        ))}
      </ButtonGroup>
    </div>
    <span className={sharedStyles.fieldValidationMessage}>{validationMessage}</span>
  </div>
);

ButtonList.propTypes = {
  fieldContract: propTypes.shape({
    allowedValues: propTypes.arrayOf(propTypes.string),
    helpText: propTypes.string,
    name: propTypes.string,
    required: propTypes.bool
  }).isRequired,
  isReadonly: propTypes.bool,
  onChange: propTypes.func.isRequired,
  selectedValue: propTypes.number.isRequired,
  updateLocation: propTypes.string.isRequired,
  validationMessage: propTypes.string
};

ButtonList.defaultProps = {
  isReadonly: false,
  validationMessage: undefined
};

export default ButtonList;
